// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_FZZ9f","layout-checkout":"layout-checkout_z6E5G","copyright":"copyright_P-HMI"};